//Exporting constants for other files
export const serverResponseConstants = {
  NETWORK_ERROR: "Network Error",
  UNAUTHORIZED_REDIRECT_DELAY_MS: 1000,
  SERVER_ISSUE: "unable_to_access_server",
  UNAUTHORIZE_ACCESS: "Unauthorize Access",
  SOMETHING_WENT_WRONG: "Something went wrong",
};
